import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NETWORKS = ['Ethereum', 'Polygon', 'BSC', 'TON', 'TON Testnet', 'Solana'];

const BASE58 = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
function sanitizeAddressByNetwork(addr, network) {
    let a = (addr || '').trim();

    if (network === 'Solana') {
        try {
            if (a.includes('://')) {
                const u = new URL(a);
                const byParam = u.searchParams.get('address');
                const parts = u.pathname.split('/').filter(Boolean);
                a = byParam || parts.pop() || a;
            }
            if (a.includes('?')) {
                a = a.split('?')[0];
            }
            const okLen = a.length >= 32 && a.length <= 48;
            const okB58 = [...a].every((c) => BASE58.includes(c));
            if (!okLen || !okB58) {
                console.warn('Likely invalid Solana address:', a);
            }
        } catch (err) {
            console.debug('Clipboard write failed:', err);
        }
    }
    return a;
}

export default function AddressForm({ onScan, preloadedAddresses = [] }) {
    const navigate = useNavigate();
    const [rows, setRows] = useState(
        preloadedAddresses.length ? preloadedAddresses : [{ address: '', network: 'Ethereum' }],
    );

    useEffect(() => {
        if (preloadedAddresses.length){
            setRows(preloadedAddresses);
        }
    }, [preloadedAddresses]);

    const addRow = () => setRows((prev) => [...prev, { address: '', network: 'Ethereum' }]);
    const removeRow = (i) => setRows((prev) => prev.filter((_, idx) => idx !== i));
    const update = (i, patch) =>
        setRows((prev) => prev.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));

    const handleSubmit = (e) => {
        e.preventDefault();
        const processed = rows.flatMap((r) =>
            (r.address || '')
                .split(',')
                .map((s) => s.trim())
                .filter(Boolean)
                .map((addr) => ({
                    address: sanitizeAddressByNetwork(addr, r.network),
                    network: r.network,
                })),
        );

        const deduped = processed.filter(
            (v, i, arr) =>
                arr.findIndex(
                    (x) =>
                        x.address.toLowerCase() === v.address.toLowerCase() &&
                        x.network === v.network,
                ) === i,
        );

        if (!deduped.length){
            return;
        }
        onScan?.({ addresses: deduped });

        const query = deduped
            .map(
                (a) =>
                    `network=${encodeURIComponent(a.network)}&address=${encodeURIComponent(
                        a.address,
                    )}`,
            )
            .join('&');
        navigate(`/scan?${query}`);
    };

    return (
        <div className="container">
            <form onSubmit={handleSubmit} className="form-container">
                <div className="address-block">
                    <label className="form-label">Addresses to scan:</label>
                    {rows.map((r, i) => (
                        <div className="address-entry" key={i}>
                            <input
                                type="text"
                                className="form-input"
                                placeholder="Enter address"
                                value={r.address}
                                onChange={(e) => update(i, { address: e.target.value })}
                            />
                            <select
                                className="form-select"
                                value={r.network}
                                onChange={(e) => update(i, { network: e.target.value })}
                            >
                                {NETWORKS.map((n) => (
                                    <option key={n} value={n}>
                                        {n}
                                    </option>
                                ))}
                            </select>
                            {rows.length > 1 && (
                                <button
                                    type="button"
                                    className="form-button remove-btn"
                                    onClick={() => removeRow(i)}
                                >
                                    -
                                </button>
                            )}
                            <button
                                type="button"
                                className="form-button add-address-btn"
                                onClick={addRow}
                            >
                                +
                            </button>
                        </div>
                    ))}
                </div>
                <button type="submit" className="form-button submit-btn">
                    Scan
                </button>
            </form>
        </div>
    );
}
